import { saveDocuments } from '../../api';
import useDocuments from '../useDocuments';

const useSaveDocuments = (data, successCallback, errorCallback) =>
  useDocuments(saveDocuments, data, successCallback, errorCallback);

export default useSaveDocuments;
